import { HeaderBreadcrumb } from '@/components/ui';
import { Route } from '@/constants';

import { ActionButtons } from './action-buttons.component';
import { CustomerInfo } from './customer-info.component';
import { DueOrders } from './due-orders.compoenent';
import { Summary } from './summary.component';

export const WholesaleCustomerDetails = () => {
    return (
        <>
            <HeaderBreadcrumb
                items={[
                    {
                        label: 'Wholesale Customers',
                        href: Route.WHOLESALE_ORDER_CUSTOMERS,
                    },
                    {
                        label: 'Wholesale Customer',
                    },
                ]}
            />
            <div className="mb-4 mt-2 grid grid-cols-1 gap-4 md:grid-cols-3">
                <div className="gap-4 space-y-4 md:col-span-2">
                    <Summary />
                    <DueOrders />
                </div>
                <div className="space-y-4">
                    <CustomerInfo />
                    <ActionButtons />
                </div>
            </div>
        </>
    );
};
